import React, { useState } from 'react';
import { Button } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PromocodeStatsAttributes } from '@loyalty/shared-common/rewards-api-client';
import { QlfConfirmationDialog, useAlerts, useConfirmationDialog } from '@qualifio/ui-commons';
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import { useTranslation } from 'react-i18next';
import { useApi } from '../../../shared/api-client/ApiClientProvider';

export function DeleteUnwonPromocodes({
  rewardId,
  onDeleted,
}: {
  rewardId: string;
  onDeleted: (promocodeStats: PromocodeStatsAttributes) => void;
}) {
  const { t } = useTranslation();

  const { notify } = useAlerts();
  const [loading, setLoading] = useState(false);
  const { rewardsApi } = useApi();

  const deleteUnwon = async () => {
    rewardsApi
      .deleteUnwonPromocodes(rewardId)
      .then(promocodeImport => {
        notify(t('rewards.promo-codes.message.delete-unwon'), 'success');
        onDeleted(promocodeImport);
      })
      .catch(() => notify(t('rewards.promo-codes.errors.delete-unwon'), 'error'))
      .finally(() => setLoading(false));
  };

  const { confirmationDialogState, setConfirmationDialogState } = useConfirmationDialog();
  const openDialog = () => {
    setConfirmationDialogState({
      title: t('rewards.promo-codes.confirm.all-deletion.title'),
      content: t('rewards.promo-codes.confirm.all-deletion.message'),
      confirmButtonText: t('generic.actions.hard-delete'),
      cancelButtonText: t('generic.actions.cancel'),
      open: true,
      onConfirm: () => deleteUnwon(),
    });
  };

  return (
    <>
      <QlfConfirmationDialog {...confirmationDialogState} />
      <Button
        color="error"
        size="small"
        startIcon={<FontAwesomeIcon icon={faTrash} />}
        disabled={loading}
        onClick={() => openDialog()}
      >
        {t('rewards.promo-codes.button.delete-all-promo-codes')}
      </Button>
    </>
  );
}
